export const REQUEST_METRICS_FOR_SELECT = "request_metrics_for_select"
export const METRICS_FOR_SELECT_SUCCESS = "metrics_for_select_success"
export const METRICS_FOR_SELECT_FAILURE = "metrics_for_select_failure"

export const CLEAR_METRICS_FOR_SELECT_STATE = "clear_metrics_for_select_state"